import axios from "axios";
import { appVersionInterceptor } from "./interceptors/appVersionInterceptor";
import { legacyApiInterceptor } from "./interceptors/legacyApiInterceptor";
import { credentialsInterceptor } from "./interceptors/credentialsInterceptor";
import { safariTokenInterceptor } from "./interceptors/safariTokenInterceptor";
import { localizationInterceptor } from "./interceptors/localizationInterceptor";
import {
   authErrorInterceptor,
   logOutUserAndRedirectToSignin,
   publicUserRetryInterceptor,
} from "./interceptors/authErrorInterceptor";
import { loggingInterceptor } from "./interceptors/loggingInterceptor";

const instance = axios.create({});

// Apply modular interceptors
instance.interceptors.request.use(credentialsInterceptor.request);
instance.interceptors.request.use(localizationInterceptor.request);
instance.interceptors.request.use(legacyApiInterceptor.request);
instance.interceptors.request.use(safariTokenInterceptor.request);

// Apply response interceptors
instance.interceptors.response.use(appVersionInterceptor.response);
instance.interceptors.response.use(loggingInterceptor.response, loggingInterceptor.responseError);
instance.interceptors.response.use(
   (response) => response,
   (error) => publicUserRetryInterceptor.responseError(error, instance),
);
instance.interceptors.response.use(
   (response) => response, // Success passthrough
   authErrorInterceptor.responseError,
);

// Export the configured instance and utility function
export { logOutUserAndRedirectToSignin };
export default instance;
